import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/sharp-solid-svg-icons";

import styles from "./form-field-label.module.scss";

type FormFieldLabelProps = {
  label: string;
  onHelpClicked?: () => void;
};

export const FormFieldLabel = ({ label, onHelpClicked }: FormFieldLabelProps) => (
  <span className={styles.labelContainer}>
    <label>{label}</label>
    {onHelpClicked && (
      <button type="button" className={styles.helpButton} onClick={onHelpClicked} aria-label="Help">
        <FontAwesomeIcon icon={faCircleInfo} className={styles.helpIcon} />
      </button>
    )}
  </span>
);
